import { DangerousHtmlContent, NotificationPanel } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { price as priceUtils, constants } from '@eti/utils';
import { CLIMATE_COMPENSATION } from '../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const ClimateCompensationNotification = ({
  priceRaw
}) => {
  const {
    t
  } = useTranslation();
  const title = t('Product.ClimateCompensation.Notification.Title');
  const content = t('Product.ClimateCompensation.Notification.Content', priceUtils.formatPrice(priceRaw !== null && priceRaw !== void 0 ? priceRaw : 0));
  return /*#__PURE__*/_jsx(NotificationPanel, {
    className: '',
    dataTestId: "climate-compensation-notification",
    icons: [{
      id: 'circle',
      color: '#18a638',
      size: '100%'
    }, {
      id: 'climate-compensation',
      color: '#fff',
      size: '66.67%'
    }],
    title: title,
    type: constants.notificationTypes.NOTIFICATION_CLIMATE_COMPENSATION,
    children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: content,
      "data-offer-rate": CLIMATE_COMPENSATION.id
    })
  });
};
export default ClimateCompensationNotification;
//# sourceMappingURL=ClimateCompensationNotification.js.map